import styled from 'styled-components';
import { fontSizeRem, heightRem } from '../constants';

export const GradientContainer = styled.div`
  top: ${fontSizeRem / 2}rem;
  border: 0.05em solid ${({ theme }): string => theme.palette.secondary.light};
  border-radius: 0.4em;
  height: ${heightRem}rem;
  margin: 0 0.3rem;
  overflow: hidden;
  pointer-events: none;
  position: relative;
  width: 1.2rem;
`;
